<template>
  <div
    :class="{
      disabled: disabled,
      // 'overflow-hidden': true, DONT HIDE breaks sticky
      'flex flex-col gap-0 rounded-xl border border-gray-300 bg-white shadow-lg': true,
    }"
    data-el="plan-card"
    :data-plan-card-subscription-id="plan.planId"
    :data-subscription-currency="plan.currency"
    :data-subscription-schedule="plan.schedule"
    :data-subscription-type="plan.subscriptionType"
    :data-plan-disabled="plan.disabled ? '1' : '0'"
  >
    <section class="sticky top-0 rounded-xl bg-white p-4">
      <!-- plan header -->
      <header class="relative mb-2 flex flex-row items-center justify-center">
        <h4 class="flex-1 text-lg font-semibold">
          {{ plan.name }}
        </h4>
        <FormBadge
          class="absolute -top-6 right-4"
          v-if="plan.name === 'Team'"
          :variant="Variant.primary"
          size="xs"
          >{{ 'Recommended' }}
        </FormBadge>
      </header>
      <!-- plan inner -->
      <div class="mb-4" data-test-id="cost" data-id="cost">
        <Price
          v-if="plan.priceF"
          :currency="plan.currency"
          :price-f="plan.priceF"
          :schedule="plan.schedule"
        />
      </div>
      <div class="text-center">
        <Btn
          class="w-full"
          v-if="plan.disabled"
          tag="button"
          disabled
          data-el="disabled-plan-button"
          :variant="Variant.secondary"
          outline
        >
          {{ 'Unsupported' }}
        </Btn>
        <Btn
          class="w-full"
          v-else-if="disabled"
          tag="button"
          disabled
          data-el="current-plan-button"
          :variant="Variant.secondary"
          outline
        >
          {{ 'Current Plan' }}
        </Btn>
        <UpgradeButton
          v-else
          :plan="plan"
          :data-id="plan.name"
          data-el="enabled-plan-button"
          :data-matching-plan="matchPlanF ? '1' : '0'"
        />
      </div>
    </section>
  </div>
</template>
<script setup lang="ts">
import type { PlanDisplay } from '@mailslurp/admin-sdk';
import Price from '../../components/pricing/Price.vue';
import UpgradeButton from '../../components/pricing/UpgradeButton.vue';
import Btn from '../form/Btn.vue';
import { Variant } from '../../store/types';
import FormBadge from '../form/FormBadge.vue';
import type { PricingQueryParams } from '../../lib/services/helpers';

const props = withDefaults(
  defineProps<{
    plan: PlanDisplay;
    disabled?: boolean;
    pricingParams?: null | PricingQueryParams;
  }>(),
  {
    pricingParams: null,
  },
);
const matchPlanF = computed<boolean>(() => {
  if (props.disabled) {
    return false;
  }
  if (!props.pricingParams) {
    return true;
  }
  if (props.pricingParams.highlightLimit) {
    return props.plan?.limits?.[props.pricingParams.highlightLimit] !== 0;
  }
  if (props.pricingParams.highlightFeature) {
    return (
      props.plan?.features?.[props.pricingParams.highlightFeature] === true
    );
  }
  return true;
});
</script>
